import { createClient, type SupabaseClient, SupportedStorage } from "@supabase/supabase-js";
import type { Database } from "./types/database.js";

export type ExcelCenterSupabaseClient = SupabaseClient<Database>;

export interface CreateSupabaseClientOptions {
	url: string;
	/** Publishable (anon) key for browser clients. */
	key: string;
	/** Optional storage key prefix; useful when multiple clients coexist. */
	storageKey?: string;
	/** Optional storage adapter; useful when multiple clients coexist. */
	storageAdapter?: SupportedStorage;
}

/**
 * Create a typed Supabase client bound to the Excel Center `Database` schema.
 * Intended for browser usage in `apps/web`; a service-role variant can be
 * added later for server tasks (ETL, scheduled jobs).
 */
export function createSupabaseClient(
	options: CreateSupabaseClientOptions,
): ExcelCenterSupabaseClient {
	const { url, key, storageKey, storageAdapter } = options;
	return createClient<Database>(url, key, {
		auth: {
			persistSession: true,
			autoRefreshToken: true,
			detectSessionInUrl: true,
			flowType: "pkce",
			storageKey,
			storage: storageAdapter,
		},
	});
}
